<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t(`admin.interfaces.pagePaymentRequest.title.${subConfig}`) }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pagePaymentRequest.card.general')" cols="12 6@desktop" rows="2">
        <!--        <card-badge :tooltip="$t('betaVersion.tooltip')">{{ $t('betaVersion.title') }}</card-badge>-->
        <hm-card-inner v-if="subConfig === 'depositConfiguration'">
          <hm-input-toggle v-model="config.depositConfiguration.enabled" :label="$t('admin.interfaces.pagePaymentRequest.enabled')" name="enabled" />
          <hm-input-select v-model="config.depositConfiguration.defaultDepositIhsId" :label="$t('admin.interfaces.pagePaymentRequest.defaultDepositIhsId')" name="defaultDepositIhsId">
            <option :value="null"></option>
            <option v-for="item in hotelSettings.inHouseServices.all(config.depositConfiguration.defaultDepositIhsId)" v-if="item.type === 'PrePayment'" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input-select v-model="config.depositConfiguration.defaultDepositPaymentTerm" :label="$t('admin.interfaces.pagePaymentRequest.defaultDepositPaymentTerm')" name="defaultDepositPaymentTerm">
            <option value="PT15M" v-html="$t('Period.PT15M')"></option>
            <option value="PT30M" v-html="$t('Period.PT30M')"></option>
            <option value="PT1H" v-html="$t('Period.P1H')"></option>
            <option value="PT3H" v-html="$t('Period.P3H')"></option>
            <option value="PT6H" v-html="$t('Period.P6H')"></option>
            <option value="PT12H" v-html="$t('Period.P12H')"></option>
            <option value="PT24H" v-html="$t('Period.P24H')"></option>
            <option value="PT48H" v-html="$t('Period.P48H')"></option>
            <option value="P1D" v-html="$t('Period.P1D')"></option>
            <option value="P3D" v-html="$t('Period.P3D')"></option>
            <option value="P7D" v-html="$t('Period.P7D')"></option>
            <option value="P10D" v-html="$t('Period.P10D')"></option>
            <option value="P14D" v-html="$t('Period.P14D')"></option>
            <option value="P21D" v-html="$t('Period.P21D')"></option>
            <option value="P30D" v-html="$t('Period.P30D')"></option>
            <option value="P1M" v-html="$t('Period.P1M')"></option>
            <option value="P2M" v-html="$t('Period.P2M')"></option>
            <option value="P3M" v-html="$t('Period.P3M')"></option>
            <option value="P6M" v-html="$t('Period.P6M')"></option>
            <option value="P1Y" v-html="$t('Period.P1Y')"></option>
          </hm-input-select>
          <hm-input-select id="depositRequestEmailTemplateId"
                           v-model="config.depositConfiguration.depositRequestEmailTemplateId"
                           :label="$t('admin.interfaces.pagePaymentRequest.depositRequestEmailTemplateId')"
                           name="depositRequestEmailTemplateId"
                           cols="12">
            <option v-if="templates.length <= 1" :value="null"></option>
            <option v-for="template in templates" :value="template.id">{{ template.name }}</option>
          </hm-input-select>
          <hm-input-select id="depositConfirmationEmailTemplateId"
                           v-model="config.depositConfiguration.depositConfirmationEmailTemplateId"
                           :label="$t('admin.interfaces.pagePaymentRequest.depositConfirmationEmailTemplateId')"
                           name="depositConfirmationEmailTemplateId"
                           cols="12">
            <option v-if="templates.length <= 1" :value="null"></option>
            <option v-for="template in templates" :value="template.id">{{ template.name }}</option>
          </hm-input-select>
        </hm-card-inner>
      </card>
      <tabable-card rows="2" cols="12 6@desktop start-1@desktop">
        <template v-for="lang in [hotelSettings.details.primaryLanguage, ...hotelSettings.details.additionalLanguages]">
          <tabable-card-content :title="$t(`lang.${lang}`)" :key="lang">
            <template v-for="paymentServiceProvider in enums.PaymentServiceProvider">
              <hm-card-inner v-if="['Manual'].includes(paymentServiceProvider)"
                             :title="$t(`PaymentServiceProvider.${paymentServiceProvider}`)"
                             :key="paymentServiceProvider">
                <hm-col cols="12">
                  <ckeditor-simple v-model="config[subConfig].paymentConfiguration[paymentServiceProvider].additionalInformation[lang]"
                                   :title="$t('admin.interfaces.pagePaymentRequest.additionalInformation')"
                                   :id="`${paymentServiceProvider}-${lang}`"/>
                </hm-col>
                <hm-button v-if="paymentServiceProvider === 'Manual'"
                           class="btn--orange btn--no-margin"
                           cols="12"
                           icon-left="refresh"
                           @click="config[subConfig].paymentConfiguration[paymentServiceProvider].additionalInformation[lang] = `<p>${hotelSettings.details.bankName}<br/>IBAN: ${(hotelSettings.details.iban || '').replaceAll(/([A-Z0-9]{4,4}(?!\s)|([A-Z0-9]{1,4}$))/gim, '$& ').trim()}<br/>BIC: ${hotelSettings.details.bic}<br/></p>`"
                >
                  {{ $t('admin.interfaces.pagePaymentRequest.resetBankDetails') }}
                </hm-button>
                <!--                <hm-textarea :label="$t('admin.interfaces.pagePaymentRequest.additionalInformation')"-->
                <!--                             v-model="config[subConfig].paymentConfiguration[paymentServiceProvider].additionalInformation.de"-->
                <!--                             type="textarea"-->
                <!--                             cols="12 start-1"-->
                <!--                             name="additionalInformation" />-->
              </hm-card-inner>
            </template>
          </tabable-card-content>
        </template>
      </tabable-card>
      <tabable-card rows="4" cols="12 6@desktop start-7@desktop">
        <template v-for="paymentServiceProvider in enums.PaymentServiceProvider">
          <tabable-card-content :title="$t(`PaymentServiceProvider.${paymentServiceProvider}`)" :key="paymentServiceProvider" :display="!disabledPaymentServiceProviders.includes(paymentServiceProvider)">
            <hm-card-inner :title="`${$t('admin.interfaces.pagePaymentRequest.card.paymentServiceProviderGeneral')} (${$t(`PaymentServiceProvider.${paymentServiceProvider}`)})`">
              <hm-input-toggle :label="$t('admin.interfaces.pagePaymentRequest.paymentServiceProviderEnabled')"
                               :enabled-title="$t('enabled')"
                               :disabled-title="$t('disabled')"
                               v-model="config[subConfig].paymentConfiguration[paymentServiceProvider].enabled"
                               cols="12 start-1"
                               name="paymentServiceProviderEnabled" />
              <hm-input-toggle v-if="['Stripe', 'Mollie'].includes(paymentServiceProvider)"
                               :label="$t('admin.interfaces.pagePaymentRequest.limitPaymentMethods')"
                               v-model="config[subConfig].paymentConfiguration[paymentServiceProvider].limitPaymentMethods"
                               cols="12 start-1"
                               name="limitPaymentMethods" />
            </hm-card-inner>
            <template v-if="config[subConfig].paymentConfiguration[paymentServiceProvider].limitPaymentMethods">
              <template v-for="paymentMethod in enums.PaymentServiceProviderPaymentMethod">
                <hm-card-inner v-if="enums.ADDITIONAL_DATA.PaymentServiceProviderPaymentMethod[paymentMethod].paymentServiceProviders.includes(paymentServiceProvider)"
                               :key="paymentMethod"
                               :title="$t(`PaymentServiceProviderPaymentMethod.${paymentMethod}`)">
                  <hm-input-toggle :label="$t('admin.interfaces.pagePaymentRequest.paymentMethodEnabled')"
                                   :enabled-title="$t('enabled')"
                                   :disabled-title="$t('disabled')"
                                   v-model="config[subConfig].paymentConfiguration[paymentServiceProvider].paymentMethods[paymentMethod].active"
                                   :disabled="!enums.ADDITIONAL_DATA.PaymentServiceProviderPaymentMethod[paymentMethod].enabled && !hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                                   cols="12 start-1"
                                   name="paymentMethodEnabled" />
                  <hm-input-range :min="0"
                                  :max="14"
                                  :step="1"
                                  :value-map="{ 0: 'Immer' }"
                                  v-model="config[subConfig].paymentConfiguration[paymentServiceProvider].paymentMethods[paymentMethod].minDaysBeforeArrival"
                                  :disabled="!enums.ADDITIONAL_DATA.PaymentServiceProviderPaymentMethod[paymentMethod].enabled && !hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                                  :label="$t('admin.interfaces.pagePaymentRequest.paymentMethodMinDaysBeforeArrival')"
                                  name="lowAvailabilityMessageThreshold" />
                </hm-card-inner>
              </template>
            </template>
          </tabable-card-content>
        </template>
      </tabable-card>

    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { cloneDeep, groupBy, isEmpty, isNil, keyBy, map, sortBy } from 'lodash';
import TabableCard from '../../../lib/layout/TabableCard';
import TabableCardContent from '../../../lib/layout/TabableCardContent';
import { TimelineMax, TweenMax } from 'gsap';
import { isProduction } from '@/lib/util/isProduction';
import TimerMixin from '../../../../mixins/TimerMixin';
import HmInputMultilang from '../../../lib/inputs/HmInputMultilang';
import HmInputToggle from '../../../lib/inputs/HmInputToggle.vue';

export default {
  name: 'PagePaymentRequestSettings',
  components: { HmInputToggle, HmInputMultilang, TabableCardContent, TabableCard, HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin, TimerMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        const storeConfig = cloneDeep(this.config);

        this.enums.PaymentServiceProvider.forEach((psp) => {
          storeConfig[this.subConfig].paymentConfiguration[psp].paymentMethods = Object.values(storeConfig[this.subConfig].paymentConfiguration[psp].paymentMethods);
        });
        // try {
        //   const paymentMethodConfigs = [];
        //   Object.values(this.paymentMethodConfigMap)
        //     .forEach((pspMethods) => {
        //       Object.values(pspMethods)
        //         .forEach(methodConfig => paymentMethodConfigs.push(methodConfig));
        //     });
        //   storeConfig.paymentConfiguration.paymentMethodConfiguration = paymentMethodConfigs;
        //   JSON.stringify(storeConfig);
        // } catch (e) {
        //   this.reportError(e);
        //   this.showErrorMessage();
        // }
        this.axios.put(this.serviceUrls.interfaces.paymentRequest.get(this, this.interfaceId), storeConfig)
          .then((response) => {
            this.showMessages(response);
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          })
          .finally(() => {
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      subConfig: 'depositConfiguration',
      config: null,
      stripeConfig: {
        enabled: false,
      },
      mollieConfig: {
        enabled: false,
      },
      fanzConfig: {
        enabled: false,
      },
      paymentMethodConfigMap: {
        Stripe: [],
        Mollie: [],
        Fanz: [],
        Manual: [],
      },
      interfaceId: this.$route.params.interfaceId,
      templates: [],
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    disabledPaymentServiceProviders: function () {
      const ret = [];

      if (!this.hasLicense('InterfaceStripe') || this.stripeConfig.enabled !== true) ret.push('Stripe');
      if (!this.hasLicense('InterfaceMollie') || this.mollieConfig.enabled !== true) ret.push('Mollie');
      if (!this.hasLicense('InterfaceFanz') || this.fanzConfig.enabled !== true) ret.push('Fanz');

      return ret;
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.paymentRequest.get(this, null))
        .then((response) => {
          const tmp = {
            ...response.data.data,
          };

          Object.values(tmp[this.subConfig].paymentConfiguration).forEach((it) => {
            if (!isNil(it.paymentMethods)) {
              it.paymentMethods = keyBy(it.paymentMethods, 'paymentMethod');
            } else {
              it.paymentMethods = {};
            }
          });

          this.enums.PaymentServiceProvider.forEach((psp) => {
            // enums.ADDITIONAL_DATA.PaymentServiceProviderPaymentMethod[paymentMethod].paymentServiceProviders.includes
            if (isNil(tmp[this.subConfig].paymentConfiguration[psp])) {
              tmp[this.subConfig].paymentConfiguration[psp] = {
                enabled: false,
                limitPaymentMethods: false,
                paymentMethods: {},
                additionalInformation: {},
              };
            }

            this.enums.PaymentServiceProviderPaymentMethod.forEach((paymentMethod) => {
              if (isNil(tmp[this.subConfig].paymentConfiguration[psp].paymentMethods[paymentMethod]) && this.enums.ADDITIONAL_DATA.PaymentServiceProviderPaymentMethod[paymentMethod].paymentServiceProviders.includes(psp)) {
                tmp[this.subConfig].paymentConfiguration[psp].paymentMethods[paymentMethod] = {
                  active: false,
                  paymentMethod: paymentMethod,
                  paymentServiceProvider: psp,
                  expiry: null,
                  minDaysBeforeArrival: 0,
                };
              }
            });
          });

          this.setTimeout(() => {
            this.config = tmp;
          }, 500);
        });
      this.axios.get(this.serviceUrls.interfaces.stripe.get(this, null))
        .then((response) => {
          this.stripeConfig = response.data.data;
        });
      this.axios.get(this.serviceUrls.interfaces.mollie.get(this, null))
        .then((response) => {
          this.mollieConfig = response.data.data;
        });
      this.axios.get(this.serviceUrls.interfaces.fanz.get(this, null))
        .then((response) => {
          this.fanzConfig = response.data.data;
        });
      this.updateTemplates();
    },
    updateTemplates() {
      this.axios.get(this.serviceUrls.templateHelper.filter(this, 'Email'))
        .then((response) => {
          this.templates = response.data.data.filter(it => it.type === 'GenericEmail' || it.type === 'PaymentConfirmationEmail');
        });
    },
    isProduction() {
      return isProduction;
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PagePaymentRequestSettings.vue